<template>
	<div class="eia-version-info">
		{{ version }}
	</div>
</template>

<script>
import config from '@/config';

export default {
	name: 'eia-version-info',
	computed: {
		version(){
			return config.version;
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-version-info {
	position: absolute;
	bottom: 0;
	right: 0;
	padding: 5px;
	font-size: 10px;
	color: #666;
}
</style>
